import { format } from 'd3-format';

const MIXED_TEXT_TOKEN = /#\{([^}]*)\}/g;

// Formats a number with a d3-format pattern, matching the AG Charts formatter syntax
// used by the custom chart (e.g. '.2s' → '1.2M', 'USD #{,.2f}' → 'USD 1,234.50').
// Returns null when the pattern is invalid so callers can fall back to their own formatting.
export const formatWithPattern = (value, pattern) => {
  if (!pattern) return null;

  try {
    if (pattern.includes('#{')) {
      return pattern.replace(MIXED_TEXT_TOKEN, (_match, spec) => format(spec)(value));
    }

    return format(pattern)(value);
  } catch (_error) {
    return null;
  }
};
